import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export function NotificationBell() {
  const nav = useNavigate();
  const [data, setData] = useState({ total: 0, items: [] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/inbox");
      setData(data);
    } catch (_e) { /* silent fail – bell stays empty */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // poll every 30s
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => { setOpen(!open); if (!open) load(); }}
        className="relative h-10 w-10 grid place-items-center rounded-md hover:bg-slate-100 transition"
        data-testid="notification-bell"
        aria-label="Notifikasi"
      >
        <Bell className="h-5 w-5 text-slate-700" />
        {data.total > 0 && (
          <span className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 bg-red-600 text-white text-[10px] font-bold rounded-full grid place-items-center" data-testid="notification-badge">
            {data.total > 99 ? "99+" : data.total}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-80 bg-white border border-slate-200 rounded-md shadow-xl z-50" data-testid="notification-panel">
          <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
            <div className="font-semibold text-sm">Notifikasi</div>
            <div className="text-xs text-slate-500">{data.total} item</div>
          </div>
          <div className="max-h-96 overflow-auto">
            {data.items.length === 0 ? (
              <div className="px-4 py-8 text-center text-sm text-slate-500" data-testid="notification-empty">
                Tidak ada notifikasi baru.
              </div>
            ) : (
              data.items.map((n) => (
                <button
                  key={n.type}
                  onClick={() => { setOpen(false); nav(n.link); }}
                  className="w-full text-left px-4 py-3 hover:bg-slate-50 border-b border-slate-100 last:border-b-0 flex items-start gap-3 transition"
                  data-testid={`notification-${n.type}`}
                >
                  <div className="h-8 w-8 rounded-full bg-red-50 text-red-700 grid place-items-center text-xs font-bold flex-shrink-0">
                    {n.count > 99 ? "99+" : n.count}
                  </div>
                  <div className="text-sm text-slate-800">{n.title}</div>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
